module.exports = __webpack_public_path__ + "static/media/logo-fit.92c1d543.svg";